// extracted by mini-css-extract-plugin
export default {"right":"Right_right__PHxoJ","message":"Right_message__ls1VU","secondMessage":"Right_secondMessage__nD+TS","page":"Right_page__iITil"};